<ng-template
	[ngIf]="field.props.actionMenuItems == null && field.props.addonMenuItems == null"
	[ngIfElse]="InputGroup">
	<input
		pInputText
		type="text"
		[class]="inputStyleClass"
		[formControl]="formControl"
		[formlyAttributes]="field" />
</ng-template>

<ng-template #InputGroup>
	<div class="p-grid">
		<div #InputGroupContainer
			class="p-inputgroup">
			<span *ngFor="let addonMenuItem of field.props.addonMenuItems"
				class="p-inputgroup-addon">
				<i [class]="addonMenuItem.getCustomIcon(formControl.value)"
					[style]="addonMenuItem.getCustomStyle(formControl.value)">
				</i>
			</span>
			<span class="input-group"
				[ngStyle]="{'width': calculatedFieldWidth}">
				<input
					pInputText
					type="text"
					[class]="inputStyleClass"
					[formControl]="formControl"
					[formlyAttributes]="field" />
			</span>
			<span class="menu-item-wrapper">
				<span *ngFor="let actionMenuItem of field.props.actionMenuItems">
					<button #ActionMenuItems
						type="button"
						pButton pRipple
						[ngStyle]="{'max-width': actionMenuItem.maxWidth}"
						[label]="actionMenuItem.label"
						[icon]="actionMenuItem.icon"
						styleClass="p-button-warn"
						[disabled]="actionMenuItem.disabled"
						[loading]="actionMenuItem.loading"
						(click)="executeActionMenuItemCommand($event, actionMenuItem)">
					</button>
				</span>
			</span>
		</div>
	</div>

	<span *ngIf="!loadingActionItems"
		clickOutside
		(clickOutside)="closeEllipsisMenu()"
		[contentDisplayed]="activeEllipsisMenu">
		<div class="ellipsis-menu {{siteLayoutService.contentCssClass}}"
			[ngStyle]="{
				'left': ellipsisMenuOffsetLeft,
				'top': ellipsisMenuOffsetTop
			}"
			[@displayAnimation]="activeEllipsisMenu ? 'visible' : 'hidden'">
			<p-scrollPanel styleClass="ellipsis-menu-container">
				<operation-menu
					#OperationMenu
					displayName="additional actions"
					class="layout-menu"
					id="ellipsis-menu"
					[initialModel]="ellipsisActionItems"
					[reset]="resetMenu"
					[pageContext]="field.props.context"
					(closeOverlays)="closeEllipsisMenu()">
				</operation-menu>
			</p-scrollPanel>
		</div>
	</span>
</ng-template>

<field-validation-message
	[field]="field">
</field-validation-message>